import { Typography, type TypographyProps } from '@mui/material'
import { FC } from 'react'

type HeaderProps = Omit<TypographyProps, 'children'> & {
  headerText?: string
}

export const Header: FC<HeaderProps> = ({ headerText, ...otherProps }) => {
  return (
    <Typography
      component="h1"
      sx={{
        fontSize: 'var(--size-3xl)',
        fontWeight: '700',
        fontStyle: 'normal',
        lineHeight: 'normal'
      }}
      {...otherProps}
    >
      {headerText}
    </Typography>
  )
}
